<style scoped>
.tax_event_row {
	background: #EEEEEE;
	margin-bottom: 5px;
	padding: 5px;
}

.tax_event_row:hover {
	background: #DDDDDD;
}

</style>

<template>
	<div class="tax_event_row" @click="edit_tax_event()">
		<div>
			<span>Tax event id {{ tax_event.event_id }}</span>
			<span>, {{ status }}</span>
			<span>, created {{ created_on }}</span>
		</div>
	</div>
</template>

<script>
import moment from 'moment';

export default {
	props: {
		tax_event: {
			type: Object,
			default: null
		},
		popup_editors: { // when used in the desktop app, we want to popup a new window so Omnis can catch this.
			type: Boolean,
			default: false
		},
	},
	computed: {
		status() {
			if (this.tax_event.status == 0) {
				return "New";
			} else if (this.tax_event.status == 1) {
				return "Sent to ATO";
			} else if (this.tax_event.status == 2) {
				return "Completed";
			} else if (this.tax_event.status == 3) {
				return "Cancelled";
			} else {
				return "Unknown";
			}
		},
		created_on() {
			return moment(this.tax_event.created_on).format("DD MMMM YYYY");
		},
	},
	methods: {
		edit_tax_event() {
			if (!this.tax_event.is_manual) {
				// Can only edit manually created items
			} else if (this.popup_editors) {
				window.open('/desktop/addressbook/' + this.tax_event.employee.id + '/payroll_header/' + this.tax_event.payroll_header.id + '/taxevent/' + this.tax_event.id)
			} else {
				// route to edit URL once we implement the web interface for this
			}
		},
	},
}
</script>
